import { render, staticRenderFns } from "./viewUnits.vue?vue&type=template&id=6d25c187"
import script from "./viewUnits.vue?vue&type=script&lang=js"
export * from "./viewUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports